import { EntityType } from "@mapmycustomers/shared";
import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import User from "@mapmycustomers/shared/types/User";

import EntityTypesSupportedInEfficiencyTracker from "@app/types/dashboard/cards/efficiencyTracker/EntityTypesSupportedInEfficiencyTracker";
import Scope from "@app/types/dashboard/Scope";

export const getScopeFilters = (
  entityType: EntityTypesSupportedInEfficiencyTracker,
  scope: Scope | undefined,
  userIds: User["id"][]
): Record<string, { [PlatformFilterOperator.CONTAINS]: User["id"][] }> => {
  if (!userIds.length) {
    return {};
  }
  const contains = { [PlatformFilterOperator.CONTAINS]: userIds };
  switch (entityType) {
    case EntityType.ACTIVITY:
      return { assigneeId: contains };
    case EntityType.DEAL:
      return scope?.userId
        ? { userId: { [PlatformFilterOperator.CONTAINS]: [scope.userId] } }
        : scope?.teamId
          ? { teamId: { [PlatformFilterOperator.CONTAINS]: [scope.teamId] } }
          : {};
    case EntityType.COMPANY:
    case EntityType.PERSON:
    default:
      return { createdBy: contains };
  }
};

export default getScopeFilters;
